import { mapState, mapGetters } from 'vuex'

export const computed = {
  ...mapGetters('accounting', ['pendingGlTransactionHeaderList']),
  ...mapState({
    hoaId: state => state.user.selectedHoaId
  })
}
